var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: _vm.formName,
      attrs: { model: _vm.form, rules: _vm.rules },
      nativeOn: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: "Retrieve failed",
              type: "error",
              description: _vm.error,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h4", [
        _vm._v(
          "Enter your email address to reset your password and retrieve your Membership Number."
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Email", "inline-message": true, prop: "email" } },
        [
          _c("el-input", {
            attrs: { placeholder: "Email", size: "medium" },
            model: {
              value: _vm.form.email,
              callback: function ($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-action" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-submit",
              attrs: { type: "primary", disabled: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.submitForm()
                },
              },
            },
            [_vm._v("\n      Retrieve")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.cancelLogIn } },
            [_vm._v("Back to login")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }